import { useAppDispatch } from "../../store/hooks";
import { dismissLoader, showLoader } from "../../store/reducers/Loader.reducer";
import { useAlert } from "./useAlert";

const loaderReferences = {
  stack: []
};

export const useLoader = () => {
  const dispatch = useAppDispatch();
  const alert = useAlert();

  const start = (message?: string) => {
    const warningTimeout = setTimeout(() => {
      alert.toastWarning("Este proceso está demorando más de lo normal, espere un momento más");
    }, 60000);

    const loaderTimeout = setTimeout(() => {
      dispatch(dismissLoader());
      alert.warning('The process has not concluded as expected, you can continue with your navigation', 'If this happens again, please contact technical support');
    }, 120000);

    loaderReferences.stack.push({ warningTimeout, loaderTimeout });
    dispatch(showLoader(message));
  };

  const stop = (stopAll: boolean = false) => {
    if (loaderReferences.stack.length === 0) return;

    stopAll
      ? clearAllLoaders()
      : clearLastLoader();

    if (loaderReferences.stack.length === 0) {
      dispatch(dismissLoader());
    }
  };

  const clearLastLoader = () => {
    const { warningTimeout, loaderTimeout } = loaderReferences.stack.pop();

    if (warningTimeout) clearTimeout(warningTimeout);
    if (loaderTimeout) clearTimeout(loaderTimeout);
  };

  const clearAllLoaders = () => {
    while (loaderReferences.stack.length > 0) clearLastLoader();
  };

  return {
    start,
    stop
  };
};
